import React from "react";

const TableCell = (props) => {
    const style={
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: "400",
        lineHeight: "24px",
        textAlign: "left",
    }
    function renderItem(param) {
        if (typeof param === "undefined" || param === null || param.length === 0) {
            return <span style={style}>-</span>;
        } else {
            return props.render ? props.render(param) : <span style={style} className={props.css}>{props.text} {props.symbol}</span>;
        }
    }

    return (
        renderItem(props.text)
    );
}

export default TableCell;